<template>
  <div class="movable">
    <slot/>
    <div
      :class="['movable__control mobile-control', {
        'blur': isBlur
      }]"
      v-if="mobile"
    >
      <div class="mobile-control__row">
        <button
          type="button"
          class="btn mobile-control__button"
          data-dir="ArrowUp ArrowLeft"
        >
          <i class="mobile-control__icon mobile-control__icon--left-up"></i>
        </button>
        <button
          type="button"
          class="btn mobile-control__button"
          data-dir="ArrowUp"
        >
          <i class="mobile-control__icon mobile-control__icon--up"></i>
        </button>
        <button
          type="button"
          class="btn mobile-control__button"
          data-dir="ArrowUp ArrowRight"
        >
          <i class="mobile-control__icon mobile-control__icon--right-up"></i>
        </button>
      </div>
      <div class="mobile-control__row">
        <button
          type="button"
          class="btn mobile-control__button"
          data-dir="ArrowLeft"
        >
          <i class="mobile-control__icon mobile-control__icon--left"></i>
        </button>
        <button
          type="button"
          class="btn mobile-control__button"
          data-dir="ArrowRight"
        >
          <i class="mobile-control__icon mobile-control__icon--right"></i>
        </button>
      </div>
      <div class="mobile-control__row">
        <button
          type="button"
          class="btn mobile-control__button"
          data-dir="ArrowDown ArrowLeft"
        >
          <i class="mobile-control__icon mobile-control__icon--left-down"></i>
        </button>
        <button
          type="button"
          class="btn mobile-control__button"
          data-dir="ArrowDown"
        >
          <i class="mobile-control__icon mobile-control__icon--down"></i>
        </button>
        <button
          type="button"
          class="btn mobile-control__button"
          data-dir="ArrowDown ArrowRight"
        >
          <i class="mobile-control__icon mobile-control__icon--right-down"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { detect } from 'detect-browser'

  export default {
    props: {
      isBlur: {
        type: Boolean,
        default: false
      },
      motionDisabled: {
        type: Boolean,
        default: false
      }
    },
    data(){
      return {
        osInfo: '',
        pressedKeys: [],
        timer: null,
        walk_timer: null,
        control: ''
      }
    },
    watch: {
      pressedKeys(value){
        if(this.timer) clearInterval(this.timer);
        if(this.walk_timer) clearInterval(this.walk_timer);

        if(value.length) {
          let action = this.parseKeys();

          if(action) {
            this.timer = setInterval(() => {
              this.$emit('action', action)
            }, 25);

            let vm = this;

            this.walk_timer = setTimeout(function walk(){
              vm.$root.$emit('play-sound', 'walk')
              vm.walk_timer = setTimeout(walk, 500);
            }, 200);
          }
        } else {
          this.stopAction();
        }
      }
    },
    created(){
      const deviceInfo = detect();
      this.osInfo = deviceInfo.os;

      document.addEventListener('keyup', this.onKeyPress);
      document.addEventListener('keydown', this.onKeyPress);
    },
    async mounted(){
      await this.$nextTick();

      window.onblur = () =>  {
        this.pressedKeys = [];
      };
      this.$on('abort_actions', () => {
        this.pressedKeys = [];
      });

      for(const button of document.querySelectorAll('button[data-dir]')){
        const direction = button.getAttribute('data-dir');

        button.addEventListener('mousedown', () => this.mobileControl(direction));
        button.addEventListener('mouseup', () => this.control !== 'keyboard' ? this.stopAction() : '');

        button.addEventListener('touchstart', () => this.mobileControl(direction));
        button.addEventListener('touchend', () => this.control !== 'keyboard' ? this.stopAction() : '');

        button.addEventListener('contextmenu', (e) => {
          e.preventDefault();
        });
      }
    },
    computed: {
      mobile(){
        return this.osInfo === 'Android OS' || this.osInfo === 'iOS' ? true : false;
      }
    },
    methods: {
      onKeyPress(e){
        e = e || event // to deal with IE

        if(this.motionDisabled || this.control === 'mobile') return;

        this.control = 'keyboard';

        if(e.type == 'keydown'){
          if(!this.pressedKeys.includes(e.code)){
            this.pressedKeys.push(e.code);
          }
        } else {
          if(this.pressedKeys.includes(e.code)){
            this.pressedKeys.splice(this.pressedKeys.indexOf(e.code), 1);
          }
        }
      },
      mobileControl(direction){
        if(this.motionDisabled || this.control === 'keyboard') return;

        this.control = 'mobile';

        const arrayOfDirections = direction.split(' ');
        this.pressedKeys = arrayOfDirections;
      },
      parseKeys(){
        const actionKeys = ['KeyF', 'KeyE'];
        const upKeys = ['KeyW', 'ArrowUp'];
        const rightKeys = ['KeyD', 'ArrowRight'];
        const downKeys = ['KeyS', 'ArrowDown'];
        const leftKeys = ['KeyA', 'ArrowLeft'];

        let moveDirs = [];

        this.pressedKeys.forEach(key => {
          if (actionKeys.includes(key)) {
            moveDirs.push('action');
            return;
          }
          if (upKeys.includes(key)) moveDirs.push('up');
          if (rightKeys.includes(key)) moveDirs.push('right');
          if (downKeys.includes(key)) moveDirs.push('down');
          if (leftKeys.includes(key)) moveDirs.push('left');
        })

        let thisAction = '';

        if(moveDirs.includes('action')) {
          thisAction = 'action';
        } else if(moveDirs.length) {
          if(moveDirs.length === 1) {
            thisAction = moveDirs[0];
          } else {
            moveDirs = moveDirs.reverse().slice(0, 2).sort();
            thisAction = moveDirs[0] + '-' + moveDirs[1];
          }
        }

        return thisAction;
      },
      stopAction(){
        if(this.control === 'mobile') this.pressedKeys = [];

        clearInterval(this.timer);
        clearInterval(this.walk_timer);

        this.control = '';
        this.$emit('action', 'stop');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .movable {
    position: relative;
    height: 100%;

    &__control {
      position: absolute;
      left: 15px;
      bottom: 15px;
    }
  }
  .mobile-control {
    width: 370px;
    height: 370px;
    transition: filter 200ms;

    &.blur {
      filter: blur(10px);
    }
    &__row {
      display: flex;
      margin-bottom: 10px;
      justify-content: space-between;

      &:last-child {
        margin-bottom: 0;
      }
    }
    &__button {
      display: flex;
      min-width: auto;
      width: 110px;
      height: 110px;
      padding: 0;
      margin: 0;
      opacity: .5;
      align-items: center;
      justify-content: center;

      &:hover {
        text-shadow: none;
      }
      &:hover i {
        filter: none;
      }
      &:active {
        opacity: 1;
        box-shadow: none;
        text-shadow: none;
        border-color: transparent;
      }
    }
    &__icon {
      display: block;
      width: 60px;
      height: 50px;
      background: url(/images/icons/arrow-mobile-control.png) no-repeat;
      background-size: cover;

      &--left-up {
        transform: rotate(45deg);
      }
      &--up {
        transform: rotate(90deg);
      }
      &--right-up {
        transform: rotate(135deg);
      }
      &--right {
        transform: rotate(180deg);
      }
      &--right-down {
        transform: rotate(-135deg);
      }
      &--down {
        transform: rotate(-90deg);
      }
      &--left-down {
        transform: rotate(-45deg);
      }
    }
  }
</style>
